import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "../BaseLayout.module.scss";

function IconLink({ link, title, icon }) {
  if (!link) {
    return (
      <div className={Style.button} style={{ opacity: 0.5, cursor: "not-allowed" }}>
        <FontAwesomeIcon
          icon={icon}
          style={{
            width: "22px",
            height: "22px",
          }}
        />

        Soon
      </div>
    );
  }

  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className={Style.link}>
      <div className={Style.button}>
        <FontAwesomeIcon
          icon={icon}
          style={{
            width: "22px",
            height: "22px",
          }}
        />

        {title}
      </div>
    </a>
  );
}

export default IconLink;